<div class="overview-container">
    <div class="title-section">
        <div class="icon-title-container">
            <div class="icon-container">
                <mat-icon svgIcon="account" class="account-icon"></mat-icon>
            </div>
            <p class="title font-poppins">My Account</p>
        </div>
        <p class="subtitle">Manage your orders, rewards, and personal details</p>
    </div>

    <div class="middle-section">
        @if (!userDetails?.user) {
        <div class="left-section">
            <div class="icon-title-container">
                <div class="icon-container">
                    <mat-icon svgIcon="user" class="user-icon"></mat-icon>
                </div>
                <p class="title font-poppins">Complete your profile</p>
            </div>

            <p class="subtitle">Add your details for faster checkout and a smoother shopping experience.</p>

            <button mat-flat-button class="complete-profile-button" (click)="clickAddUserDetails()">
                Complete Profile
                <mat-icon svgIcon="rightarrow" iconPositionEnd class="arrow-icon"></mat-icon>
            </button>
        </div>

        <div class="right-section">
            <div class="icon-container">
                <mat-icon svgIcon="addprofile" class="addprofile-icon"></mat-icon>
            </div>
        </div>
        } @else {
        <div class="image-detail-container">
            <div class="image-container">
                @if (userDetails?.user?.profileImage) {
                <img class="user-image" [src]="userDetails?.user?.profileImage" />
                } @else {
                <span class="user-image-icon">
                    {{ userDetails?.user?.name! | initials: 2 }}
                </span>
                }
            </div>

            <div class="user-details">
                <p class="user-name font-poppins">
                    {{ userDetails?.user?.name }}
                </p>
                <p class="user-mobile">
                    <mat-icon svgIcon="phone" class="phone-icon"></mat-icon>
                    <span class="mobile-number"> +91 {{ userDetails?.user?.userMobileNumber }} </span>
                </p>
                <p class="user-email">
                    <mat-icon svgIcon="mail" class="email-icon"></mat-icon>
                    {{ userDetails?.user?.email }}
                </p>
            </div>
        </div>
        }
    </div>

    <div class="bottom-section">
        <div class="title-container">
            <div class="icon-container tertiary-bg-icon">
                <mat-icon svgIcon="orderaccount" class="account-icon"></mat-icon>
            </div>
            <p class="title font-poppins">Orders & Account Overview</p>
        </div>

        <div class="orders-section">
            <div class="section">
                <div class="left-section">
                    <div class="icon-container primary-bg-icon">
                        <mat-icon svgIcon="order" class="section-icon"></mat-icon>
                    </div>

                    <div class="text-container">
                        <p class="title font-poppins">Your Orders</p>
                        <p class="subtitle">Check your order status</p>
                    </div>
                </div>

                <div class="right-section">
                    <a routerLink="/account/trackOrder">
                        <mat-icon svgIcon="rightarrow" iconPositionEnd class="arrow-icon"></mat-icon>
                    </a>
                </div>
            </div>

            <div class="section">
                <div class="left-section">
                    <div class="icon-container secondary-bg-icon">
                        <mat-icon svgIcon="wishlist" class="section-icon"></mat-icon>
                    </div>

                    <div class="text-container">
                        <p class="title font-poppins">Wishlist</p>
                        <p class="subtitle">All your curated product collection</p>
                    </div>
                </div>

                <div class="right-section">
                    <a routerLink="/wishlist">
                        <mat-icon svgIcon="rightarrow" iconPositionEnd class="arrow-icon"></mat-icon>
                    </a>
                </div>
            </div>

            <div class="section">
                <div class="left-section">
                    <div class="icon-container tertiary-bg-icon">
                        <mat-icon svgIcon="starborder" class="section-icon"></mat-icon>
                    </div>

                    <div class="text-container">
                        <p class="title font-poppins">Rewards</p>
                        <p class="subtitle">Manage all your rewards</p>
                    </div>
                </div>

                <div class="right-section">
                    <a routerLink="/account/rewards">
                        <mat-icon svgIcon="rightarrow" iconPositionEnd class="arrow-icon"></mat-icon>
                    </a>
                </div>
            </div>

            <div class="section">
                <div class="left-section">
                    <div class="icon-container primary-bg-icon">
                        <mat-icon svgIcon="location" class="section-icon"></mat-icon>
                    </div>

                    <div class="text-container">
                        <p class="title font-poppins">Addresses</p>
                        <p class="subtitle">Save addresses for hassale-free delivery</p>
                    </div>
                </div>

                <div class="right-section">
                    <a routerLink="/account/addressDetails">
                        <mat-icon svgIcon="rightarrow" iconPositionEnd class="arrow-icon"></mat-icon>
                    </a>
                </div>
            </div>

            <div class="section">
                <div class="left-section">
                    <div class="icon-container secondary-bg-icon">
                        <mat-icon svgIcon="giftbox" class="section-icon"></mat-icon>
                    </div>

                    <div class="text-container">
                        <p class="title font-poppins">Coupons</p>
                        <p class="subtitle">Manage coupons for additional discounts</p>
                    </div>
                </div>

                <div class="right-section">
                    <mat-icon svgIcon="rightarrow" iconPositionEnd class="arrow-icon"></mat-icon>
                </div>
            </div>

            <div class="section">
                <div class="left-section">
                    <div class="icon-container tertiary-bg-icon">
                        <mat-icon svgIcon="user" class="section-icon"></mat-icon>
                    </div>

                    <div class="text-container">
                        <p class="title font-poppins">Profile Details</p>
                        <p class="subtitle">Change your profile Details</p>
                    </div>
                </div>

                <div class="right-section">
                    <a routerLink="/account/profileDetails">
                        <mat-icon svgIcon="rightarrow" iconPositionEnd class="arrow-icon"></mat-icon>
                    </a>
                </div>
            </div>
        </div>
    </div>
</div>
